import {createSelector} from 'reselect';
import {getExperiment, isRedirectToLoginExperiment} from './ExperimentSelectors';
import {getSettings, isGuest} from './selectors';

export default createSelector(
  [getExperiment, getSettings, isGuest, isRedirectToLoginExperiment],
  (experiments, settings, guest, inRedirectToLoginExperiment) => {
    if (guest && settings.show_return_to_login) {
      return experiments?.show_return_to_login_wave_01
        ? inRedirectToLoginExperiment : true;
    }
    
    return false;
  },
);
